// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3tH7M","controls":"styles_controls__3qvZY","charLimit":"styles_charLimit__2Jrd6","input":"styles_input__3bHDO","send":"styles_send__HpP-r"};